// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sheet-bg[data-v-9b67ca88]{background-color:hsla(0,0%,100%,.1)}", ""]);
// Exports
module.exports = exports;
